import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  header: {
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin', 'background'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.sidebarWidthClose,
      width: `calc(100% - ${theme.sidebarWidthClose}px)`,
    },
  },
  headerExpanded: {
    backgroundColor: 'transparent',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.sidebarWidth,
      width: `calc(100% - ${theme.sidebarWidth}px)`,
      backgroundColor: theme.palette.common.white,
    },
  },
  headerFullwidth: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  headerToolbar: {
    paddingRight: theme.spacing(3), // keep right padding when drawer closed
  },
  headerTrigger: {
    color: theme.palette.primary.main,
  },
  headerTriggerOpen: {
    color: theme.palette.common.white,
  },
  headerNotifications: {
    color: theme.palette.primary.main,
    transition: theme.transitions.create(['color'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
  headerNotificationsOpen: {
    [theme.breakpoints.down('xs')]: {
      color: theme.palette.common.white,
    },
  },
  headerTitleWrap: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  headerTitleIcon: {
    marginRight: theme.spacing(2),
  },
  headerTitleText: {
    color: theme.palette.primary.dark,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  headerLanding: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  headerTitleTextLanding: {
    color: theme.palette.common.white,
  },
  headerButtonLanding: {
    color: theme.palette.common.white,
  },
  headerLandingExpanded: {
    backgroundColor: theme.palette.primary.dark,
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
}))

export default useStyles
